'use client';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Layout } from '@/shared/ui/layout';
import {
    ProductCardAddToCartButton,
    Icon as ProductCardAddToCartButtonIcon,
    Text as ProductCardAddToCartButtonText,
} from './product-card-add-to-cart-button';
import { ProductCardAvailability } from './product-card-availability';
import { ProductCardBottomOverlayWrapper } from './product-card-bottom-overlay-wrapper';
import { ProductCardContentWrapper } from './product-card-content-wrapper';
import { ProductCardDescription } from './product-card-description';
import { ProductCardImage } from './product-card-image';
import { ProductCardName } from './product-card-name';
import { ProductCardOriginalPrice } from './product-card-original-price';
import { ProductCardPrice } from './product-card-price';
import { ProductCardSelect } from './product-card-select';
import { ProductCardTags } from './product-card-tags';
import { ProductCardProps } from './types';

export const ProductCardHoverableVariant = ({
    tags,
    isImageVisible,
    imageUrl,
    isNameVisible,
    name,
    availability,
    description,
    isDescriptionVisible,
    variants,
    defaultVariantId,
    priceValues,
}: ProductCardProps) => {
    const getLocalizedValue = useGetLocalizedValue();
    const localizedName = getLocalizedValue(name);

    return (
        <>
            <ProductCardImage
                localizedName={localizedName}
                isImageVisible={isImageVisible}
                imageUrl={imageUrl}
            >
                <ProductCardTags tags={tags} variant="inImage" />
                <ProductCardBottomOverlayWrapper>
                    <ProductCardAvailability availability={availability} />
                    <ProductCardName localizedName={localizedName} isNameVisible={isNameVisible} />
                </ProductCardBottomOverlayWrapper>
            </ProductCardImage>
            <ProductCardAvailability availability={availability} variant="strip" />
            <ProductCardContentWrapper>
                <ProductCardName localizedName={localizedName} isNameVisible={isNameVisible} />
                <ProductCardTags tags={tags} />
                <ProductCardDescription
                    description={description}
                    isDescriptionVisible={isDescriptionVisible}
                />
                <ProductCardSelect variants={variants} defaultVariantId={defaultVariantId} />
                <Layout>
                    <ProductCardPrice priceValues={priceValues} />
                    <ProductCardOriginalPrice priceValues={priceValues} />
                    <ProductCardAddToCartButton>
                        <ProductCardAddToCartButtonIcon />
                        <ProductCardAddToCartButtonText />
                    </ProductCardAddToCartButton>
                </Layout>
            </ProductCardContentWrapper>
        </>
    );
};
